<template>
  <div class="accordion accordion-light">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Accordion'
}
</script>
